module.exports = __webpack_public_path__ + "static/media/myPhoto.084f7574.jpg";